import { Card, Grid2, Tooltip } from '@mui/material'
import { push } from '@lagunovsky/redux-react-router'
import { flatten, maxBy, minBy, orderBy } from 'lodash'
import moment from 'moment'
import 'moment/locale/fr'
import PropTypes from 'prop-types'
import DtoAnalysis from 'quality/dto/DtoAnalysis'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import WaitAction from 'wait/WaitAction'
import HydrometryAction from '../../../../../hydrometry/actions/HydrometryAction'
import DtoHydrometricBruteMeasure from '../../../../../hydrometry/dto/DtoHydrometricBruteMeasure'
import DtoHydrometryDataTypeSituation from '../../../../../hydrometry/dto/DtoHydrometryDataTypeSituation'
import DtoParametrageDataType from '../../../../../piezometry/dto/DtoParametrageDataType'
import AppStore from '../../../../../store/AppStore'
import { getDate } from '../../../../../utils/DateUtil'
import { getHardHydroDataTypes } from '../../../../../utils/HydroUtils'
import { hasBooleanValue } from '../../../../../utils/NumberUtil'
import { execByType } from '../../../../../utils/StationUtils'
import { arrayOf, getLabel, instanceOf } from '../../../../../utils/StoreUtils'
import { STATION_TYPE_NAME } from '../../../../constants/StationConstants'
import DtoHydrometerAdditionalMeasures from '../../../../dto/hydrometricStation/DtoHydrometerAdditionalMeasures'
import DtoMeasureStats from '../../../../dto/piezometer/DtoMeasureStats'
import DtoPiezometerAdditionalMeasures from '../../../../dto/piezometer/DtoPiezometerAdditionalMeasures'
import DtoPiezometerSample from '../../../../dto/piezometer/DtoPiezometerSample'
import DtoPiezometryStationMeasure from '../../../../dto/piezometer/DtoPiezometryStationMeasure'
import DtoOperation from '../../../suivipc/qualitometer/dto/DtoOperation'
import DtoQualitoDashboard from '../../../../../quality/components/dashboard/dto/DtoQualitoDashboard'
import { NewTable } from '../../../../../components/datatable/NewTable'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import InfoIcon from '@mui/icons-material/Info'

moment.locale('fr')

class StationDashboardKeyFigurePanel extends Component {
    constructor(props) {
        super(props)
        this.handleClick = this.handleClick.bind(this)
    }

    componentDidMount() {
        if (this.props.stationTypes.includes('hydrometry')) {
            this.props.fetchHydrometryDataTypes().then(() => {
                const dataTypes = [ ...getHardHydroDataTypes(), ...this.props.hydrometryDataTypes ]
                this.props.loadHydrometryRawSituations([parseInt(this.props.id)], dataTypes.map(d => d.id))
            })
        }
    }

    getDateByMinOrMax = (list, filter) => {
        const result = filter(list, (o) => {
            return o.date
        })
        if (result) {
            return getDate(result.date)
        }
        return ''
    }

    getLastDateWithStatus = (tabMeasures, status) => {
        const filteredMeasures = tabMeasures.filter(measure => measure.validity == status)
        return filteredMeasures.length !== 0 ? getDate(moment(maxBy(filteredMeasures, 'date').date)) : ''
    }

    getMeasuresData = () => {
        if (this.props.measures.length) {
            return {
                title: 'Chronique',
                begin: getDate(moment(minBy(this.props.measures, 'date').date)),
                end: getDate(moment(maxBy(this.props.measures, 'date').date)),
                nbOperation: this.props.measures.length,
                control: this.getLastDateWithStatus(this.props.measures, '2'),
                validation: this.getLastDateWithStatus(this.props.measures, '3'),
            }
        }
        return []
    }

    getKeyFiguresObj = (measures, title, dateKey = 'date') => {
        return {
            title,
            begin: measures.length ? getDate(minBy(measures, dateKey)[dateKey]) : '',
            end: measures.length ? getDate(maxBy(measures, dateKey)[dateKey]) : '',
            nbOperation: measures.length,
            control: this.getLastDateWithStatus(measures, 2),
            validation: this.getLastDateWithStatus(measures, 3),
        }
    }


    getHistory = () => {
        return flatten(execByType(this.props.stationTypes[0], {
            quality: () => {
                const hydrobioBeginDate = this.getDateByMinOrMax(this.props.hydrobioOperations, minBy)
                const hydrobioEndDate = this.getDateByMinOrMax(this.props.hydrobioOperations, maxBy)
                const operationsData = (() => {
                    const stats = this.props.qualitoDashboard?.stats
                    if (stats) {
                        return [{
                            title: <b>{i18n.physicochemical}</b>,
                            begin: getDate(stats.startDate),
                            end: getDate(stats.endDate),
                            nbOperation: stats.nbOperations,
                            nbAnalysis: stats.nbAnalysis,
                            control: getDate(stats.nv1),
                            validation: getDate(stats.nv2),
                        }, {
                            title: <b>{i18n.hydrobiology}</b>,
                            begin: hydrobioBeginDate,
                            end: hydrobioEndDate,
                            nbOperation: this.props.hydrobioOperations.length,
                            nbAnalysis: '',
                            validation: hydrobioEndDate,
                            control: '',
                        }].filter(s => s.nbOperation)
                    }
                    return []
                })()
                return operationsData.concat(this.getMeasuresData())
            },
            piezometry: () => {
                return orderBy(this.props.piezometerStatistics, 'order', 'asc').map(stat => {
                    const comment = stat?.comment ? (
                        <Tooltip title={ stat.comment}>
                            <InfoIcon
                                style={{ fontSize: 18, color: 'grey' } }
                            />
                        </Tooltip>
                    ) : ''
                    const displayOff = stat?.showData === false ? (
                        <Tooltip title={i18n.displayDisabled}>
                            <VisibilityOffIcon
                                style={{ fontSize: 18, color: 'grey' } }
                            />
                        </Tooltip>
                    ) : ''
                    return {
                        title: <Grid2 container spacing={1} alignItems={'center'} fontWeight={'bold'}>{stat.label} {comment} {displayOff}</Grid2>,
                        ...(this.isMultiPoint() ? { point: stat.namePoint } : {}),
                        begin: getDate(stat.startDate),
                        end: getDate(stat.endDate),
                        nbOperation: stat.countTotal || '',
                        control: getDate(stat.control),
                        validation: getDate(stat.validation),
                    }
                }).filter(s => s.nbOperation)
            },
            hydrometry: () => {
                const dataTypes = [ ...getHardHydroDataTypes(), ...this.props.hydrometryDataTypes ]
                return this.props.hydrometryDataTypeSituation.filter(m => dataTypes.find(t => t.id === m.dataTypeId).displayData || !hasBooleanValue(dataTypes.find(t => t.id === m.dataTypeId).displayData)).map(stat => ({
                    title: getLabel(dataTypes, stat.dataTypeId, null, 'id'),
                    begin: stat.startDate ? getDate(stat.startDate) : '',
                    end: stat.lastMeasureDate ? getDate(stat.lastMeasureDate) : '',
                    nbOperation: stat.allMeasuresCount || '',
                })).filter(s => s.nbOperation)
            },
            default: () => {
                return []
            },
        }))
    }

    isMultiPoint = () => execByType(this.props.stationTypes[0], {
        piezometry: () => this.props.piezometerStatistics.some(stat => this.props.piezometerStatistics.some(stat2 => stat.typeId === stat2.typeId && stat.codepoint !== stat2.codepoint)),
        default: () => false,
    })

    getHeader = () => {
        return execByType(this.props.stationTypes[0], {
            hydrometry: () => {
                return [
                    { key: 'title', value: i18n.statistics },
                    'begin',
                    'end',
                    { key: 'nbOperation', value: i18n.nbMeasures },
                ]
            },
            default: () => {
                return [
                    { key: 'title', value: i18n.statistics },
                    this.isMultiPoint() ? { key: 'point', value: i18n.pointPrelevement } : null,
                    'begin',
                    'end',
                    this.props.stationTypes[0] === STATION_TYPE_NAME.piezometry ? { key: 'nbOperation', value: i18n.nbMeasures } : { key: 'nbOperation', value: i18n.nbOperations },
                    this.props.stationTypes[0] === STATION_TYPE_NAME.quality ? { key: 'nbAnalysis', value: i18n.nbAnalysis } : null,
                    'control',
                    'validation',
                ].filter(s => !!s)
            },
        })
    }

    redirect = (key) => {
        const arr = this.props.location.pathname.split('/')
        arr.splice(arr.length - 1, 1)
        const pathname = arr.join('/')
        const path = (() => {
            switch (key) {
                case 'Physico-chimique':
                    return `${pathname}/suiviPC`
                default:
                    return null
            }
        })()
        if (path) {
            AppStore.dispatch(push(path))
        } else {
            AppStore.dispatch(WaitAction.waitStop())
        }
    }

    handleClick(key) {
        AppStore.dispatch(WaitAction.waitStart())
        setTimeout(() => this.redirect(key), 1)
    }

    render() {
        const history = this.getHistory()
        const filteredHistory = history.filter(e => e && e.nbOperation !== 0)
        return (
            <Card sx={{ border: '1px solid grey', borderRadius: '5px', width: '100%', boxShadow: 'none' }}>
                <NewTable
                    rows={filteredHistory}
                    rowsPerPageOptions={-1}
                    headers={this.getHeader()}
                />
            </Card>
        )
    }
}

StationDashboardKeyFigurePanel.propTypes = {
    id: PropTypes.string.isRequired,
    stationTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
    operations: PropTypes.arrayOf(PropTypes.instanceOf(DtoOperation)),
    hydrobioOperations: PropTypes.arrayOf(PropTypes.instanceOf(DtoOperation)),
    analysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysis)),
    measures: PropTypes.arrayOf(PropTypes.instanceOf(DtoPiezometryStationMeasure)),
    router: PropTypes.object,
    includesCardTitle: PropTypes.bool,
    piezometerMeasureBrute: PropTypes.arrayOf(PropTypes.instanceOf(DtoPiezometryStationMeasure)),
    piezometerMeasureMin: PropTypes.arrayOf(PropTypes.instanceOf(DtoPiezometryStationMeasure)),
    piezometerAdditionalMeasures: PropTypes.arrayOf(PropTypes.instanceOf(DtoPiezometerAdditionalMeasures)),
    piezometryDataTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoParametrageDataType)),
    samples: PropTypes.arrayOf(PropTypes.instanceOf(DtoPiezometerSample)),
    piezometerStatistics: arrayOf(DtoMeasureStats),
    hydrometryDataTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoParametrageDataType)),
    hydrometryBruteMeasures: PropTypes.arrayOf(PropTypes.instanceOf(DtoHydrometricBruteMeasure)),
    hydrologicalAdditionalMeasures: PropTypes.arrayOf(PropTypes.instanceOf(DtoHydrometerAdditionalMeasures)),
    hydrometryDataTypeSituation: PropTypes.arrayOf(PropTypes.instanceOf(DtoHydrometryDataTypeSituation)),
    loadHydrometryRawSituations: PropTypes.func,
    fetchHydrometryDataTypes: PropTypes.func,
    location: PropTypes.shape({ pathname: PropTypes.string }),
    qualitoDashboard: instanceOf(DtoQualitoDashboard),
}

StationDashboardKeyFigurePanel.defaultProps = {
    includesCardTitle: true,
}

const mapStateToProps = store => ({
    operations: store.SuivipcReducer.operations,
    hydrobioOperations: store.OperationReducer.hydrobioOperations,
    analysis: store.SuivipcReducer.analysis,
    measures: store.PiezometerStationReducer.measures,
    router: store.router.locationBeforeTransitions,
    piezometerMeasureBrute: store.PiezometerStationReducer.piezometerMeasureBrute,
    piezometerMeasureMin: store.PiezometerStationReducer.piezometerMeasureMin,
    piezometerAdditionalMeasures: store.PiezometerStationReducer.piezometerAdditionalMeasures,
    piezometryDataTypes: store.PiezometryReducer.piezometryDataTypes,
    samples: store.PiezometerStationReducer.samples,
    piezometerStatistics: store.PiezometerStationReducer.piezometerStatistics,

    hydrometryDataTypes: store.HydrometryReducer.hydrometryDataTypes,
    hydrometryBruteMeasures: store.HydrometryReducer.hydrometryBruteMeasures,
    hydrologicalAdditionalMeasures: store.HydrometerStationReducer.hydrologicalAdditionalMeasures,
    hydrometryDataTypeSituation: store.HydrometryReducer.hydrometryDataTypeSituation,
    qualitoDashboard: store.QualityReducer.qualitoDashboard,
})


const mapDispatchToProps = {
    loadHydrometryRawSituations: HydrometryAction.loadHydrometryRawSituations,
    fetchHydrometryDataTypes: HydrometryAction.fetchHydrometryDataTypes,
}

export default connect(mapStateToProps, mapDispatchToProps)(StationDashboardKeyFigurePanel)
